import React, { useContext, useState } from 'react';
import { TextField, Avatar, List, ListItem, ListItemAvatar, ListItemText, InputAdornment, Grid, Typography, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { LanguageContext } from '../../libs/Context';

const teamMembers = [
	{ name: 'Emilia', role: 'HR Executive', avatar: 'https://prod.ucwe.capgemini.com/in-en/wp-content/uploads/sites/18/2022/09/EXPERIENCED-PROFESSIONALS-1.jpg' },
	{ name: 'greeplant pvt.Lmtd.', role: 'vendor', avatar: 'https://cdn.pixabay.com/photo/2020/08/05/13/27/eco-5465459_1280.png' },
	{ name: 'Indica', role: 'Partner', avatar: '/images/icons/companylogo.svg' },
	{ name: 'Jenna', role: 'Business Executive', avatar: 'https://www.shutterstock.com/image-photo/black-woman-working-office-conversation-600nw-2312841711.jpg' },
	{ name: 'Roser Davidson', role: 'Business Executive', avatar: 'https://www.shutterstock.com/image-photo/black-woman-working-office-conversation-600nw-2312841711.jpg' },
	{ name: 'Floyda Miles', role: 'Business Executive', avatar: '/images/floyd.png' }
];

function Searchlist(props)
{
	const { type } = props;
	const [ selectedMembers, setSelectedMembers ] = useState<string[]>([]);
	const [ searchTerm, setSearchTerm ] = useState<string>('');
	const { language } = useContext(LanguageContext);

	const handleToggleMember = (member: string) =>
	{
		const newChecked = [ ...selectedMembers, member ];

		setSelectedMembers(newChecked);
		setSearchTerm(''); // Close the list by clearing search term
	};

	const handleRemoveMember = (member: string) =>
	{
		setSelectedMembers((prev) => prev.filter((selected) => selected !== member));
	};

	const filteredMembers = teamMembers.filter(
		(member) => member.name.toLowerCase().includes(searchTerm.toLowerCase())
	);

	return (
		<>
			<Grid container flexDirection={'column'}>
				<Grid item xs={12}>
					<TextField
						fullWidth
						variant='standard'
						size='small'
						placeholder={props.placeholder || language?.searchByNameComompany}
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						InputProps={{
							startAdornment : (
								<InputAdornment position='start'>
									<SearchIcon />
								</InputAdornment>
							)
						}}
					/>
				</Grid>
				{/* Member List */}
				<Grid item xs={12}>
					{searchTerm &&
					<List sx={{ maxHeight: 'var(--font280)', overflowY: 'auto', paddingTop: 'var(--pixel4)', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '0 0 8px 8px', boxShadow: ' 0px 1px 2px rgb(0,0,0,0.2)' }}>
						{filteredMembers.length > 0
							? (
								filteredMembers.map((member) => (
									<ListItem
										key={member.name}
										onClick={() => handleToggleMember(member.name)}
										sx={{
											cursor          : 'pointer',
											backgroundColor : 'inherit',
											color           : 'inherit',
											padding         : '0 12px',
											marginBottom    : '8px'
										}}
									>
										<ListItemAvatar sx={{ minWidth: 'var(--pixel40)' }}>
											<Avatar alt={member.name} src={member.avatar} sx={{ border: '1px solid rgba(0,0,0,0.12)', width: 'var(--pixel32)', height: 'var(--pixel32)', fontSize: 'var(--pixel16)' }} />
										</ListItemAvatar>
										<ListItemText primary={member.name} secondary={type !== 'chat' && member.role} sx={{ textTransform: 'capitalize' }} />
									</ListItem>
								))
							)
							: (
								<Typography variant='body2' color='textSecondary' justifyContent={'center'} display={'flex'} my='var(--pixel16)'>
									{language?.noSearchAvailable}
								</Typography>
							)}
					</List>}
				</Grid>
			</Grid>
			<Box display='flex' sx={{ width: 'var(--percent100)' }} pt='var(--pixel8)' gap={1} flexWrap={'wrap'}>
				{selectedMembers.map((member) =>
				{
					const memberData = teamMembers.find((m) => m.name === member);

					return (
						<Grid
							item
							key={member}
							sx={{
								display      : 'flex',
								alignItems   : 'center',
								border       : '1px solid rgba(0,0,0,0.12)',
								borderRadius : '25px',
								padding      : '2px 6px',
								maxWidth     : '170px',
								overflow     : 'hidden',
								textOverflow : 'ellipsis',
								background   : 'transparent'
							}}
						>
							<Avatar src={memberData?.avatar} sx={{ marginRight: 'var(--pixel8)', border: '1px solid rgba(0,0,0,0.12)', width: 'var(--pixel30)', height: 'var(--pixel30)' }} />
							<Box display='flex' flexDirection='column' alignItems='flex-start' overflow={'hidden'} pr='var(--pixel4)'>
								<Typography variant='body2' fontWeight='500' textOverflow={'ellipsis'} whiteSpace={'nowrap'} width={'var(--percent100)'} overflow={'hidden'}>
									{memberData?.name}
								</Typography>
								{type !== 'chat' && <Typography variant='caption' color='textSecondary' textOverflow={'ellipsis'} whiteSpace={'nowrap'} width={'100%'} overflow={'hidden'}>
									{memberData?.role}
								</Typography>}
							</Box>
							<CloseIcon
								onClick={() => handleRemoveMember(member)} fontSize='small'
								sx={{ color: 'var(--primaryColor)', cursor: 'pointer' }}
							/>
						</Grid>
					);
				})}
			</Box>
		</>
	);
}

export default Searchlist;
